<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="EPF Contribution Rate"
      text="Edit EPF Contribution Rate"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="localEpf.wages_from"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('from')"
              data-vv-name="from"                
              data-vv-as="From"      
              prefix="RM"          
              label="From"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEpf.wages_to"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('to')"
              data-vv-name="to"                
              data-vv-as="To"  
              prefix="RM"          
              label="To"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEpf.employee_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('employee_contribution')"
              data-vv-name="employee_contribution"                
              data-vv-as="Employee Contribution"                
              label="Employer Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEpf.employer_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('employer_contribution')"
              data-vv-name="employer_contribution"                
              data-vv-as="Employer Contribution"                
              label="Employer Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEpf.total_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('total_contribution')"
              data-vv-name="total_contribution"                
              data-vv-as="Total Contribution"                
              label="Total Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="localEpf.category"
              :error-messages="errors.collect('category')"
              :items="categories"
              data-vv-name="key"
              data-vv-as="category"
              item-text="name"
              item-value="key"
              label="EPF Category / Part"
            />
          </v-col>
        </v-row> 
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      epf: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        categories: [
          { key: 'A', name: 'A' },
          { key: 'E', name: 'E' },
        ],
        dialog: null,
        progressing: false,
        localEpf: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localEpf = { ...this.epf }
        this.localEpf.wages_from = (this.localEpf.wages_from / 100).toFixed(2)
        this.localEpf.wages_to = (this.localEpf.wages_to / 100).toFixed(2)
        this.localEpf.employer_contribution = (this.localEpf.employer_contribution / 100).toFixed(2)
        this.localEpf.employee_contribution = (this.localEpf.employee_contribution / 100).toFixed(2)
        this.localEpf.total_contribution = (this.localEpf.total_contribution / 100).toFixed(2)
        this.localEpf.category = this.localEpf.category
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.epf().update(this.localEpf.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.dialog = false 
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          wages_from: this.localEpf.wages_from * 100,
          wages_to: this.localEpf.wages_to * 100,
          employer_contribution: this.localEpf.employer_contribution * 100,
          employee_contribution: this.localEpf.employee_contribution * 100,
          total_contribution: this.localEpf.total_contribution * 100,
          category: this.localEpf.category,
        }
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
